import http from '@/http-common'
import Title from "@/components/TitlePage.vue";

export default {
  name: "ReportEkp",
  components: {Title},
  data() {
    return {
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      stickyHeader: true,
      items: [],
      dat1: null,
      dat2: null,
      downloadFileLink: '',
      dfileName: '',
      modalLoadOpened: false,
      columns: [],
      columns_default: [
        {key: 'nameEvent', label: 'Наименование', sortable: true, stickyColumn: true, variant: "primary"},
        {
          key: 'dateEvent', label: 'Дата проведения', sortable: true, variant: "primary",
          sortByFormatted: true, formatter: (value, key, item) => {
            return item.dateBegin;
          }
        },
        {key: 'cdate', label: 'Дата создания', sortable: true, variant: "primary"},
        {key: 'loginC', label: 'Кем создан', sortable: true, variant: "primary"},
        {key: 'location', label: 'Место', sortable: true, variant: "primary"},
        {key: 'locationAddress', label: 'Адрес', sortable: true, variant: "primary"},
        {key: 'heldCheck', label: 'Проведено', variant: "primary"},
        {key: 'smetaRespFio', label: 'Ответственный', variant: "primary"},
        {key: 'smetaRespPhoneTel', label: 'Тел ответственного', variant: "primary"},
        {key: 'smetaManagerFio', label: 'Заполнил', variant: "primary"},
        {key: 'summ', label: 'Сумма по ЕКП', variant: "primary"},
        {key: 'summaSmeta', label: 'Сумма по смете', sortable: true, variant: "primary"},
        {key: 'summaReturn', label: 'Возврат', variant: "primary"},
        {key: 'summaBalance', label: 'Остаток', variant: "primary"},
        {key: 'changeCheck', label: 'Изменения', variant: "primary"},
        {key: 'sportKind', label: 'Раздел ЕКП', sortable: true, variant: "primary"},
        {key: 'eventKind', label: 'Статус', sortable: true, variant: "primary"},
        {key: 'ekpType', label: 'Вид ЕКП', sortable: true, variant: "primary"},
        {key: 'jobKind', label: 'Вид работ', sortable: true, variant: "primary"},
        {key: 'federation', label: 'Федерация', sortable: true, variant: "primary"},
        {key: 'countDocs', label: 'Кол-во документов', sortable: true, variant: "primary", tdClass: "getClassCol"}
      ],
      heads: [{name: 'Характеристики', count: 20}],
      orgList: [],
      ekpTypeList: [],
      reportTypeList: [],
      selectOrg_id: 0,
      selectEkpTypeId: 0,
      modalDetailOpened: false,
      factList: [],
      factFields: [
        {key: 'cost_name', label: 'Статья'},
        {key: 'fact', label: 'Факт'},
        {key: 'comment', label: 'Комментарий'},
        {key: 'checkedPay', label: 'Оплачено'}
      ]
    }
  },
  created() {
    this.dat1 = new Date().getFullYear().toString() + "-01-01";
    this.dat2 = new Date().getFullYear().toString() + "-12-31";
    this.loadOrgs();
    this.loadEkpTypes()
    let vm = this;
    vm.columns_default.forEach(function (col) {
      vm.columns.push(col)
    });
  },
  methods: {
    loadCost(ids) {
      let vm = this;
      http.get('/cost/listByIds?ids=' + ids)
      .then((response) => {
        let costs = response.data;
        costs.forEach(function (x) {
          let head = {};
          if (x.childs.length > 0) {
            head.name = x.nameCost;
            head.count = x.childs.length;
            vm.heads.push(head);
            x.childs.forEach(function (child) {
              let col = {};
              col.key = 'facts.cost_' + child.id;
              col.label = child.nameCost;
              col.variant = "info"
              col.id = child.id;
              vm.columns.push(col);
            })
          } else {
            head.name = '';
            head.count = 1;
            vm.heads.push(head);
            let col = {};
            col.key = 'facts.cost_' + x.id;
            col.label = x.nameCost;
            col.id = x.id;
            vm.columns.push(col);
          }
        })
      })
      .catch((error) => console.log(error.message))
      .finally(() => {
        vm.$forceUpdate()
      });
    },
    loadFacts(ekp_id, cost_id) {
      let vm = this;
      http.get('/report/ekp/cost/' + ekp_id + '?cost_id=' + cost_id)
      .then(resp => {
        vm.factList = resp.data.facts;
        vm.modalDetailOpened = true
      })
    },
    loadItems() {
      let vm = this;
      vm.columns = [];
      vm.columns_default.forEach(function (col) {
        vm.columns.push(col)
      });
      let filter = 'org_id=' + this.selectOrg_id;
      filter += '&ekptype_id=' + this.selectEkpTypeId;
      if (this.dat1) {
        filter += '&dat1=' + this.dat1;
      }
      if (this.dat2) {
        filter += '&dat2=' + this.dat2;
      }
      this.modalLoadOpened = true;
      http.get('/report/ekp2?' + filter)
      .then((response) => {
        vm.items = response.data.list;
        let ids = response.data.cost_ids;
        vm.items.forEach(function (x) {
          x.facts = JSON.parse(x.dataJson);
        })
        vm.loadCost(ids.join());
      })
      .catch((error) =>
          console.log(error.response.data)
      )
      .finally(() => vm.modalLoadOpened = false);
    },
    validate_date(value) {
      let arrD = value.split("-"); // yyyy-mm-dd
      arrD[1] -= 1;
      let sTmp = arrD[0] + '-' + arrD[1] + '-' + arrD[2];
      return new Date(sTmp) !== 'Invalid Date';
    },
    checkDate1() {
      if (this.validate_date(this.dat1) && this.dat1 > this.dat2) {
        this.dat2 = this.dat1
      }
    },
    // checkDate2() {
    //     if (this.validate_date(this.dat2) && this.dat2 < this.dat1)
    //         this.dat1 = this.dat2
    // },
    exportExcel() {
      this.downloadFileLink = '';
      let vm = this;
      let ids = [];
      vm.columns.forEach(function (x) {
        if (x.id) {
          ids.push(x.id);
        }
      })
      if (vm.items && vm.items.length > 0) {
        vm.modalLoadOpened = true;
        http.post('/report/ekp/excel?ids=' + ids.join(), vm.items)
        .then((response) => {
          if (response.data.ok || response.data.name !== '') {
            vm.downloadFileLink = '/report/download?name=' + encodeURIComponent(response.data.name);
            vm.dfileName = 'Общая таблица ЕКП.xls';
          } else {
            alert("Таблица не сформирована!");
          }
        })
        .catch((error) => console.log(error.response.data))
        .finally(() => vm.modalLoadOpened = false);

      } else {
        alert("Таблица пустая!");
      }
    },
    getBalance(rec) {
      return rec.summ - rec.summaSmeta + rec.summaReturn;
    },
    downloadFile() {
      let vm = this;
      this.modalLoadOpened = true;
      http.get(this.downloadFileLink,
          {
            responseType: 'arraybuffer',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/pdf'
            }
          }
      ).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', vm.dfileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      }).finally(() => vm.modalLoadOpened = false);
    },
    loadOrgs() {
      let vm = this;
      http.get('/option/orglist')
      .then((response) => {
        vm.orgList = response.data;
        vm.selectOrg_id = vm.orgList[0].value
      })
      .catch((error) => console.log(error.message));
    },
    loadEkpTypes() {
      let vm = this;
      http.get('/workkind/EKP_TYPE/list')
      .then((response) => {
        vm.ekpTypeList = response.data;
        vm.ekpTypeList.forEach(function (x) {
          x.value = x.id;
          x.text = x.name;
        })
        vm.selectEkpTypeId = vm.ekpTypeList[0].id
      })

    },
    showDetail(props) {
      let key = props.field.key;
      if (key.indexOf('_') >= 0) {
        key = key.substr(key.indexOf('_') + 1);
      }
      this.loadFacts(props.item.id, key);
    },
    getStyleCol(item) {
      if (item.checked === 'false') {
        return "red"
      }
    }
  }
}
